import React, { useState, useEffect } from "react";
import { Typography, Box, TextField } from "@mui/material";
import {
  WrapperOfLogin,
  ContainerOfLoginForm,
  TextLogin,
  LeftSide,
  RightSide,
} from "./ThemeModal";
import { useTranslation } from "react-i18next";

import { toast } from "react-toastify";
import Cookies from 'universal-cookie'
import { useNavigate } from "react-router-dom";
import * as BsIocne from 'react-icons/bs'
import * as TbIcons from 'react-icons/tb'

import LoginAnimationBg from '../LoginAnimationBG/LoginAnimationBg'
import Preloading from "../Preload/Preloading";

import { useSelector, useDispatch } from "react-redux";

import userAPI from "../../Network/User";
import { selectRoles, setRolesRedux } from "../../reduxStore/RolesReducer";
const cookies = new Cookies();

export default function Login() {
  const [t] = useTranslation("common");
  const dispatch = useDispatch();
  const controller = new AbortController();
  const theme = useSelector(state => state.themeData);
  const token = cookies.get('token')
  const [userName, setUserName] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const logintheme = useSelector((state) => state.themeData.logintheme);
  const screenwidth = useSelector((state) => state.settingsData.screenwidth);
  const rolesRedux = useSelector(selectRoles)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const setUserNameValue = (e) => {
    setUserName(e.target.value);
  };
  const setUserPasswordValue = (e) => {
    setUserPassword(e.target.value);
  };
  const setShowPasswordField = (e) => {
    setShowPassword(true);
  };
  const setHidePasswordField = (e) => {
    setShowPassword(false);
  };
 

  function clearAllCookies() {
    // Get all cookies
    const cookies = document.cookie.split(";");
  
    // Loop through each cookie and delete it
    cookies.forEach((cookie) => {
      const cookieName = cookie.split("=")[0].trim();
  
      // Set the cookie expiration date to the past
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
  
    console.log('All cookies cleared');
  }
  
  useEffect(() => {
    clearAllCookies()
    var w = window.screen.availWidth;
    var h = window.screen.availHeight;

  }, []);

  

  const login = async () => {
    
    if (!userName) {
      toast.warning(t("ERROR.login_username_error"));
      return
    } else if (!userPassword) {
      toast.warning(t("ERROR.login_userpassword_error"));
      return
    }
    // if (userName != 'is_admin' || userPassword != 'password') {
    //   toast.warning(t("ERROR.userName_or_password_error"));
    //   return
    // }
    setLoading(true)
    

    const result = await userAPI.login({
      data:{
        username: userName,
        password: userPassword,
      },
      
      signal: controller?.signal
    })

    if (result.status) {
      
      if (result && result?.status && result?.data?.status) {
        cookies.set("token", result?.data?.data?.token, { path: "/" })
        cookies.set('id', result?.data?.data?.id, { path: '/' });
        if (result?.data?.data?.roles) {
          handleCheckIdExists(result?.data?.data?.roles)
        }
      }
      else{
        toast.error(result?.data?.data?.text)
      }
      setTimeout(() => {
        setLoading(false)
      }, 4000)
    }
    else {
      if (typeof result?.errorMessage === "object") {
          
          const errorMessagesKeys = Object.keys(result?.errorMessage);
          let messages = ""
          errorMessagesKeys?.map((key) => {
              
              result?.errorMessage[key].map((message) => {
                  messages += " - " + message
              })
              
          })
          
          toast.error(messages)
      }
      else {
        toast.error(result?.errorMessage)
      }


  }
  setLoading(false)
  };
  const handleCheckIdExists = (roles) => {


    if (rolesRedux) {


      const updatedRoles = Object.entries(rolesRedux).reduce(
        (acc, [key, value]) => {
          if (roles?.includes(value?.id)) {
            acc[key] = { ...value, value: true };
          } else {
            acc[key] = value;
          }
          return acc;
        },
        {}
      );


      dispatch(setRolesRedux(updatedRoles));
    }
  };
  if (token && !loading) {
    navigate('/system/main_units_installation_check')
  } else {
    return (
      <WrapperOfLogin
        className="d-flex justify-content-center align-items-center containerOfLogin"
        logintheme={logintheme}
        screenwidth={screenwidth}
      >
        
        {
          loading ?
            <Preloading />
             : 
            null
        }

        <ContainerOfLoginForm logintheme={logintheme} screenwidth={screenwidth}>
          <Box className="wrapperLoginContent">
            <TextLogin logintheme={logintheme} screenwidth={screenwidth}>
              {t("LOGIN.login_title")}
            </TextLogin>
            <RightSide logintheme={logintheme} screenwidth={screenwidth}>
              <Box className="ContainerOfRight d-flex flex-column justify-content-center align-items-center">
                <Typography variant="p" className="welcome-message">
                  {t("LOGIN.welcome_message")+" "+theme?.app_name}
                </Typography>
                <Box className="subContainerRight">

                  {/* <Typography variant='p' className="Introductory-message">{t('LOGIN.Introductory_message')}</Typography> */}
                  <Typography
                    sx={{
                      fontSize: {
                        xxl: "16px !important",
                        xl: "16px !important",
                        lg: "14px !important",
                        md: "15px !important",
                        sm: "16px !important",
                        xs: "16px !important",
                      },
                    }}
                    variant="p"
                    className="Introductory-message"
                  >
                    {t("LOGIN.Introductory_message")}
                  </Typography>

                  <TextField
                    
                    variant="filled"
                    label={t("LOGIN.user_name")}
                    value={userName}
                    onChange={setUserNameValue}
                    className="user-name"
                  />
                  <Box sx={{ position: "relative" }} className="bassword-box">
                    <TextField
                      
                      variant="filled"
                      label={t("LOGIN.user_password")}
                      value={userPassword}
                      onChange={setUserPasswordValue}
                      className="user-password"
                      type={showPassword ? "text" : "password"}
                    />
                    {!showPassword ? (
                      <BsIocne.BsEye
                        className="passwordIcon"
                        onClick={setShowPasswordField}
                        size={27}
                      />
                    ) : (
                      <BsIocne.BsEyeSlash
                        className="passwordIcon"
                        onClick={setHidePasswordField}
                        size={27}
                      />
                    )}
                  </Box>

                  {/* <FormControlLabel
                    value="left"
                    control={
                      <Checkbox
                        checked={rememberMe}
                        onChange={setRememberMeValue}
                      />
                    }
                    label={t("LOGIN.checkbox_remember_me")}
                    // labelPlacement={t('LOGIN.checkbox_remember_me')}
                    className="checkbox-remember-me"
                  /> */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignContent: "center",
                      alignItems: "center",
                      width: "88%",
                    }}
                  >
                    <Typography
                      variant="span"
                      className="login-text"
                      onClick={login}
                    >
                      {t("LOGIN.login")}
                    </Typography>
                    {/* <img
                      src={loginImage}
                      alt="login"
                      className="login-img"
                      onClick={login}
                    /> */}
                    <TbIcons.TbLogin  
                      style={{
                        fontSize:'30px',
                        color:logintheme?.iconsColor,
                        cursor: 'pointer',
                      }}
                      onClick={login}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "88%",
                    }}
                  >
                    {/* <Typography
                      variant="span"
                      className="forget-password"
                      onClick={showRestPasswordFormFunction}
                    >
                      {t("LOGIN.forget_password")}
                    </Typography> */}
                  </Box>
                </Box>
              </Box>
            </RightSide>
            <LeftSide logintheme={logintheme} screenwidth={screenwidth}>
              <Box className="ContainerOfLeft">
                <img src={theme.images.companyOne} alt="logo for company" />
                <Box className="ContainerOfLeft_texts">
                  <Typography variant="span" className="company-name">
                    {t("LOGIN.company_name")}
                  </Typography>
                  
                </Box>
              </Box>
            </LeftSide>
          </Box>

          <Box className="footer-message">
           <span>{t("LOGIN.footer_message")}</span> 
           <img
             src={theme.images.companyTwo}
             style={{
              width:'55px',
              height:'45px',
              objectFit:'cover',
              backgroundPosition:'center center',
              margin:'0 10px',
              
             }}
           />
          </Box>

        </ContainerOfLoginForm>
        <LoginAnimationBg />

      </WrapperOfLogin>
    );
  }
}
